import { DossierSearchItem, DossierSearchType, userGridType } from '@app/pcs/models';
import { Action } from '@ngrx/store';

export enum DossierSearchActionTypes {
  SearchDossiers = '[Search] Search Dossiers',

  SearchDossiersSuccess = '[Search] Search Dossiers Success',
  SearchDossiersFail = '[Search] Search Dossiers Fail',
  InitDossiersInLocalStorage = '[Search] Init Dossiers In Local Storage',

  SetSearchResults = '[Search] Set Search Results',
  SetSearchResultsForFilter = '[Search] Set Search Results For Filter'
}

export class SearchDossiers implements Action {
  readonly type = DossierSearchActionTypes.SearchDossiers;
  constructor(public payload?: DossierSearchType) {}
}

export class SearchDossiersSuccess implements Action {
  readonly type = DossierSearchActionTypes.SearchDossiersSuccess;
  constructor(public payload: DossierSearchType) {}
}

export class SearchDossiersFail implements Action {
  readonly type = DossierSearchActionTypes.SearchDossiersFail;
  constructor(public payload: Error) {}
}

export class InitDossiersInLocalStorage implements Action {
  readonly type = DossierSearchActionTypes.InitDossiersInLocalStorage;
}

export class SetSearchResults implements Action {
  readonly type = DossierSearchActionTypes.SetSearchResults;
  constructor(public payload: { searchResults: DossierSearchItem[]; dossierSearchType: DossierSearchType;
    userGridConfiguration: any; }) {
  }
}

export class SetSearchResultsForFilter implements Action {
  readonly type = DossierSearchActionTypes.SetSearchResultsForFilter;
  constructor(public payload: DossierSearchItem[]) {}
}

export type DossierSearchActions =
  | SearchDossiersSuccess
  | SearchDossiersFail
  | InitDossiersInLocalStorage
  | SetSearchResults
  | SetSearchResultsForFilter;

export const setSearchResults = (searchResults, dossierSearchType, userGridConfiguration) => {
  const gridConfiguration = {
    userGridType: userGridType(dossierSearchType),
    configuration: userGridConfiguration?.configuration
  };
  return new SetSearchResults({searchResults, dossierSearchType, userGridConfiguration: gridConfiguration});
};
